<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--7 spin-content">
            <div class="row ml-2 mb-10 regular-header">
                <div class="col-auto" style="padding: 0px;">
                    <router-link :to="{ name: 'product explorer'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Product List </h6>
                    </router-link>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header px-4 py-3 bg-transparent">
                            <div class="row px-3">
                                <h6 class="heading-small p-0 m-0"> {{parentProduct.name}} </h6>
                                <div class="col d-flex justify-content-end">
                                    <i v-if="parentProduct.product_type == ''" class="fas fa-shopping-bag"></i> &nbsp; &nbsp; <h6 class="heading-small p-0 m-0 mr-2"> {{product_type_text}} PRODUCT </h6>
                                </div>
                            </div>
                        </div>
                        <div class="card-body mx-4">
                            <div class="row mt-2">
                                <div class="col">
                                    <h6 class="heading-small text-muted">Barcode</h6>
                                    {{parentProduct.barcode}}
                                </div>                        
                                <div class="col">
                                    <h6 class="heading-small text-muted">Stock No</h6>
                                    {{parentProduct.stock_no}}
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col">
                                    <h6 class="heading-small text-muted">Supplier</h6>
                                    {{parentProduct.supplier_name}}
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Category</h6>
                                    {{parentProduct.category_tree.division_name}} / {{parentProduct.category_tree.department_name}} / {{parentProduct.category_tree.section_name}} / {{parentProduct.category_tree.category_name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br>
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card mb-3">
                            <div class="row no-gutters">
                                <div class="col-md-12">
                                    <div class="card-body pt-0">
                                        <br>
                                        <div class="row align-items-center">
                                            <div class="col-md-12">
                                                <div v-if="successMessage != null">
                                                    <base-alert type="primary" dismissible>
                                                        <span class="alert-inner--text"> {{successMessage}}</span>
                                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </base-alert>
                                                </div>
                                            </div>

                                            <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="visible">
                                                <div>
                                                    <product-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :productType="productType" :key="componentKey"></product-form>
                                                </div>
                                            </a-drawer>

                                            <stock-card v-if="selectedProduct != null" :product="selectedProduct" :key="stockCardKey" :visible="stockCardVisible"></stock-card>

                                            <div class="col">
                                                <div class="table-responsive pt-2">
                                                    <div id="example-table"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductForm from "../Products/ProductForm";
    import StockCard from '../Products/StockCard.vue';
    import HTTPRequest from '../../controllers/httpRequest.js';
    import secureStorage from '../../controllers/secureStorage';
    import axios from "axios";

    import {
        mapState,
        mapActions
    } from 'vuex'
    
    import Tabulator from 'tabulator-tables';
    var table;
    var component_x;

    export default {
        components: {
            StockCard,
            ProductForm,
        },
        data: function() {
            return {
                product_type_text: '',
                parentProduct: {
                    product_type: '',
                    barcode: '',
                    stock_no: '',
                    supplier_name: '',
                    category_tree: {
                        division_name: '',
                        department_name: '',
                        section_name: '',
                        category_name: ''
                    },
                    children: []
                },
                successMessage: null,
                options: {
                    height: "100%",
                    layout:"fitDataStretch",
                    pagination:"local",
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false,
                            formatter:"textarea"
                        },
                        {
                            title: 'REF CODE',
                            field: 'reference_code',
                            width: "20%",
                            headerSort: false
                        },                  
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "10%",
                            headerSort: false
                        },
                        {
                            title: 'STATUS',
                            field: 'status',
                            width: "8%",
                            headerSort: false
                        },
                        {
                            title: 'ACTIONS',
                            width: "17%",
                            headerSort: false,
                            formatter: this.addButton,
                            cellClick: this.selectPromoAction
                        }
                    ]
                },
                accessRights: [],
                activeModules: [],
                visible: false,
                windowWidth: 0,
                componentKey: 0,
                stockCardVisible: false,
                selectedProduct: null,
                stockCardKey: 0,
                productType: "",
                product_id: this.$route.params.id
            }
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function() {
            component_x = this;

            if (component_x.product_id > 0){
                let categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MDM-001', null, null)
                this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                let accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + this.activeModules[0].id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[this.activeModules[0].id]
                }else {
                    this.accessRights = []
                }

                component_x.allData()

                component_x.$nextTick(function() { //for fullscreen drawer
                    window.addEventListener('resize', component_x.getWindowWidth);
                    component_x.getWindowWidth()
                })
            }
        },
        methods: {
            ...mapActions(['updateProfileId']),
            addButton (cell, formatterParams){
                let id = cell.getRow().getData().id
                let button = ""

                if(this.serverType == 'ho'){
                    if(this.accessRights.includes('V')){
                        button += '<div class="text-center"><button id="add_' + id + '" name="View" class="btn btn-success btn-sm">View</button>'
                    }
                    if(this.accessRights.includes('W')){
                        button += '<button id="edit_' + id + '" name="Edit" class="btn btn-sm btn-warning">Edit</button>'
                    }
                    if(this.accessRights.includes('D')){
                        button += '<button id="delete_' + id + '" name="Delete" class="btn btn-sm btn-danger">Delete</button></div>'
                    }
                } else {
                    if(this.accessRights.includes('V')){
                        button += '<div class="text-center"><button id="add_' + id + '" name="View" class="btn btn-success btn-sm">View</button>'
                    }
                }
                
                return button
            },
            allData: async function(){
               let product_data = await HTTPRequest.getRequest(this.endPoint + '/products/' + this.product_id + '/get_children_details', null, null)
                if(product_data != undefined){
                    component_x.parentProduct = product_data 
                    if(product_data.product_type == ''){
                        component_x.product_type_text = 'Regular'
                    } else if (product_data.product_type == 'M'){
                        component_x.product_type_text = 'Matrix'
                    }
                    
                    if(product_data.children != null){
                        this.options.data = product_data.children
                    } else {
                        this.options.data = []
                    }
                    
                    table = new Tabulator("#example-table", this.options);
                }
            },
            selectPromoAction: function(e, cell){
                if(e.target.id != ""){
                    let detail_id = cell.getRow().getData().id
                    let product_type = cell.getRow().getData().product_type

                    switch (e.target.name) {
                    case "View":
                        this.viewMode = true
                        this.showModal(detail_id)
                        break;
                    case "Edit":
                        this.viewMode = false
                        this.showDrawer(detail_id, product_type)
                        break;
                    case "Delete":
                        let result = confirm("You are about to delete this record?");
                        if (result) {
                            this.deleteData(detail_id)
                        }
                        
                        break;
                    default:
                        break;
                    }
                }
            },
            deleteData: async function(id){
                axios({
                    method: 'delete',
                    url: this.endPoint + 'products/' + id,
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
                    },
                })
                .then(function () {
                    component_x.successMessage = "Successfully deleted record"
                    component_x.refreshPage()
                })
            },
            refreshPage() {
                this.allData()
                this.successMessage = "Successful Operation"
                this.onClose()
            },
            onClose() {
                this.visible = false
                this.componentKey++
            },
            closeDrawer(){
                this.onClose()
            },
            getWindowWidth(event) { //for fullscreen drawer
                this.windowWidth = window.innerWidth
            },
            showDrawer(id, type) {
                this.componentKey++
                this.updateProfileId(id)
                this.productType = type
                this.visible = true
            },
            showModal(id){
                this.stockCardVisible = true
                this.selectedProduct = id;
                this.stockCardKey++;
            },
        }
    }
</script>

<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
    .tabulator-group-toggle{
        display: none;
    }
</style>